import React, { useEffect, useRef } from "react";

const Canvas = ({ canvasTitle, onRequestClose, canvasComponent }) => {
  const divRef = useRef(null);
  // Use useEffect to add an event listener to the document
  useEffect(() => {
    divRef.current.scrollIntoView({ behavior: "smooth" });
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        // Close the canvas when the Escape key is pressed
        onRequestClose();
      }
    }

    // Prevent scolling
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    // Clear things up when unmounting this component
    return () => {
      document.body.style.overflow = "visible";
      document.removeEventListener("keydown", onKeyDown);
    };
  });

  return (
    <div
      ref={divRef}
      className="backdrop absolute bottom-0 left-0 overflow-auto right-0 top-0 z-9999"
    >
      <div className="flex flex-col w-full md:w-1/3 bg-white absolute right-0 top-0 p-8 min-h-screen">
        <div>
          <div
            className="flex justify-end cursor-pointer"
            onClick={onRequestClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-x-circle w-6 h-6"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
          <div className="flex justify-between mt-5">
            <h3 className="text-main-color text-2xl"> {canvasTitle} </h3>
          </div>
        </div>

        <div className="mt-8">{canvasComponent}</div>
      </div>
    </div>
  );
};

export default Canvas;
